import axios from "axios";
import { env } from "../../../enums";
export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getSlides() {
      return new Promise(function(resolve, reject) {
        axios.get(env.base_url + `/slideshow`).then(result => {
          if (result.status == 200) {
            resolve(result.data.item);
          }
          reject("");
        });
      });
    },
    getTopBanners() {
      return new Promise(function(resolve, reject) {
        axios.get(env.base_url + `/banner/top`).then(result => {
          if (result.status == 200) {
            resolve(result.data.item);
          }
          reject("");
        });
      });
    }
  }
};
